import React, { useState } from "react";
import SideBar from "./event-selection/sideBar";
import { NavLink } from "react-router-dom";
import ProfileManagement from "./ProfileManagement";

const Header: React.FC = () => {
  const [open, setOpen] = useState(false);

  return (
    <section className="fixed z-20 grid top-0 w-full bg-[#1E408E] h-24">
      <SideBar open={open} setOpen={setOpen} />

      <div className="flex items-center justify-between px-[10px] lg:px-10">
        <div className="flex gap-5 shrink-0">
          <button onClick={() => setOpen(!open)}>
            <img src="/images/Menu.png" alt="menu" />
          </button>
          <div className="sm:block hidden">
            <NavLink to="/event-collect" className="cursor-pointer">
              <img src="/images/logo-dark.png" alt="logo" />
            </NavLink>
          </div>
        </div>
        <ProfileManagement />
      </div>
    </section>
  );
};

export default Header;
